<div class="field">
  <label class="field__label">
    <span>{{ label }}</span>
    @if (required) {
      <span class="field__req" aria-hidden="true">*</span>
    }
    @if (showInfoIcon()) {
      <button
        #infoTrigger
        type="button"
        class="field__info"
        [class.field__info--open]="isOpen()"
        aria-label="Informações do campo"
        (click)="toggleInfo()">
        i
      </button>
    }
  </label>

  <div class="field__control">
    <ng-content></ng-content>
  </div>

  @if (hint) {
    <span class="field__hint">{{ hint }}</span>
  }
</div>
